export default function scrollToTop() {
  // Scrolls the document to the top
  window.scrollTo({
    top: 0,
    left: 0,
    behavior: 'smooth', // Optional: Add smooth scrolling behavior
  })
}
